const TRANSLATIONS_MODE = {
  admin: 'admin',
  api: 'api',
  clientPanel: 'frontend',
};

export default TRANSLATIONS_MODE;
